import { InlineMessage } from '@pm/ui';
import { useTranslation } from 'react-i18next';
import { TimePicker } from '../../components/Datepicker/TimePicker';
import { useAppointmentTimeSlots } from '../../hooks/use-appointment-time-slots/use-appointment-time-slots';
import { LoadingPage } from '../../pages/LoadingPage';

type AppointmentTimesProps = {
  bookingSessionId: string;
  date: Date;
  timeFieldName: string;
  providerFieldName: string;
};
export const AppointmentTimes = ({
  bookingSessionId,
  date,
  timeFieldName,
  providerFieldName,
}: AppointmentTimesProps) => {
  const { t } = useTranslation('appointments', { keyPrefix: 'Appointment' });
  const { availableTimeSlots, loading, error } = useAppointmentTimeSlots(
    bookingSessionId,
    date,
    { skip: !bookingSessionId },
  );

  // An empty bookingSessionId means the caller's own session is still
  // starting (e.g. switching in-person clinics tears down and restarts one)
  // - not a genuine "zero slots" result, so don't show the error state for it.
  if (loading || !bookingSessionId) {
    return <LoadingPage />;
  }

  if (error !== undefined || availableTimeSlots.length === 0) {
    return (
      <InlineMessage
        intent="error"
        title={t('Errors.Times.Heading') ?? ''}
        instructions={t('Errors.Times.Description')}
      />
    );
  }

  return (
    <TimePicker
      timeSlots={availableTimeSlots}
      timeFieldName={timeFieldName}
      providerFieldName={providerFieldName}
    />
  );
};
